
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.553 9.038h6.903v1.176H8.553V9.038zm0 1.743h6.903v1.176H8.553V10.78zm0 1.66h4.604v1.177H8.553v-1.176z","fill":"#516FFF"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 0c6.629 0 12 5.371 12 12s-5.371 12-12 12S0 18.629 0 12 5.371 0 12 0zM8.674 15.926L6.25 18.278V8.141c0-.783.638-1.426 1.42-1.426h8.736c.783 0 1.426.643 1.426 1.426v6.36c0 .782-.643 1.425-1.426 1.425H8.674z","fill":"#516FFF"}})])
          )
        }
      }
    